import { apiClient } from './apiClient';

// Export the API client as 'api' for convenience
export const api = apiClient;
